import React from "react"
import Circle, { FinishedCircle, NowCircle } from "../atoms/circle"
import styled from "styled-components"
import media from "styled-media-query"

const Wrap = styled.div`
  margin: -5px auto 10px auto;
  width: 100%;
  ${media.greaterThan("small")`
    margin: -7px auto 0 auto;
  `}
`
const StyledTd = styled.td`
  padding: 0;
`
const MainTd = styled(StyledTd)`
  font-family: "Teko", sans-serif;
  font-weight: 600;
  text-align: center;
  height: 5px;
  width: 8px;
  ${media.greaterThan("small")`
    width: 12px;
  `}
`
const SubTd = styled(StyledTd)``
const TdText = styled.p`
  color: #0247aa;
  display: inline-block;
  font-size: 12px;
  font-family: "Teko", sans-serif;
  font-weight: 600;
  height: 0;
  letter-spacing: 1px;
  margin: 0;
  transform: translateX(-100%);
  width: 10px;
  word-break: normal;
`
const StyledTable = styled.table`
  width: 99%;
  ${media.greaterThan("small")`
    width: 58%;
  `}
`
const StyledBorder = styled.p`
  line-height: 100%;
  margin: -6px 0;
  text-align: center;
  ${media.greaterThan("small")`
    font-size: 16px;
    letter-spacing: 3px;
    margin: -10px 0;
  `}
`
const StyledBike = styled.img`
  width: 28px;
  ${media.greaterThan("small")`
    transform: translateX(-10px);
    width: 50px;
  `}
`

const Progress = props => {
  const resultList = props.resultList
  const no = props.index
  const bike1 = require("../../images/bike/01.gif")
  const bike2 = require("../../images/bike/02.gif")
  const bike3 = require("../../images/bike/03.gif")
  let bike

  let row1: JSX.Element[] = new Array(18)
  let row2: JSX.Element[] = new Array(18)
  let row3: JSX.Element[] = new Array(18)

  var tmpCount = 0
  for (let i = 0; i <= props.index; i++) {
    if (resultList[i]) {
      tmpCount = tmpCount + 1
    } else if (resultList[i] === null) {
    } else {
      tmpCount = 0
    }
  }
  if (tmpCount === 0) {
    bike = bike1
  } else if (tmpCount === 1) {
    bike = bike2
  } else if (tmpCount > 1) {
    bike = bike3
  }

  for (let index = 0; index <= 18; index++) {
    // Bike
    if (index / 2 === no) {
      row1[index] = (
        <MainTd key={index + "-1"}>
          <TdText>
            <StyledBike src={bike} alt="bike" />
          </TdText>
        </MainTd>
      )
    } else {
      row1[index] = <SubTd key={index + "-1"} />
    }

    // Start or Goal
    if (index / 2 === no && index !== 0 && index !== 18) {
      row2[index] = <MainTd key={index + "-2"}>{no + 1}</MainTd>
    } else {
      if (index === 0) {
        row2[index] = (
          <MainTd key={index + "-2"}>
            <TdText>START</TdText>
          </MainTd>
        )
      } else {
        if (index === 18) {
          row2[index] = (
            <MainTd key={index + "-2"}>
              <TdText style={{ transform: "translateX(-80%)" }}>GOAL</TdText>
            </MainTd>
          )
        } else {
          row2[index] = <SubTd key={index + "-2"} />
        }
      }
    }
    // Circle or Border
    if (index % 2 === 0) {
      if (index / 2 === no) {
        row3[index] = (
          <MainTd key={index + "-3"}>
            <NowCircle />
          </MainTd>
        )
      } else {
        switch (resultList[index / 2]) {
          case null:
            row3[index] = (
              <MainTd key={index + "-3"}>
                <Circle />
              </MainTd>
            )
            break
          case true:
            row3[index] = (
              <MainTd key={index + "-3"}>
                <FinishedCircle correct={true} />
              </MainTd>
            )
            break
          case false:
            row3[index] = (
              <MainTd key={index + "-3"}>
                <FinishedCircle correct={false} />
              </MainTd>
            )
            break
        }
      }
    } else {
      row3[index] = (
        <SubTd key={index + "-3"} style={{ fontSize: "10px" }}>
          <StyledBorder>----</StyledBorder>
        </SubTd>
      )
    }
  }
  let Table: JSX.Element
  Table = (
    <StyledTable style={{ margin: "auto", color: "#0247aa" }}>
      <tbody>
        <tr style={{ transform: "translateY(8px)" }}>{row1}</tr>
        <tr>{row2}</tr>
        <tr>{row3}</tr>
      </tbody>
    </StyledTable>
  )

  return <Wrap>{Table}</Wrap>
}

export default Progress
